import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { EventDetails } from "@/store/site-monitor/types";
import { MatrixContents } from "@/store/site-monitor-cameras/types";

const SiteMonitor = namespace("siteMonitor");
const SiteMonitorCameras = namespace("siteMonitorCameras");
const Session = namespace("sessions");

@Component
export default class MatrixSidebarMixin extends Vue {
	@SiteMonitor.Getter("getIsController") public isController: any;
	@SiteMonitor.Getter("getEventDetails") public eventDetails: EventDetails;

	@SiteMonitorCameras.Getter("getLayouts") public layouts: number[][];
	@SiteMonitorCameras.Getter("getLayoutIndex") public layoutIndex: number;
	@SiteMonitorCameras.Getter("getAllMatrixContents") public allMatrixContents: MatrixContents;

	@Session.Getter public getSession: (resourceId: number | string) => string;
	@Session.Action public updateSession: ({
		resourceId,
		eventId
	}: {
		resourceId: number | string;
		eventId: number;
	}) => Promise<void>;

	public get eventId() {
		return this.eventDetails ? this.eventDetails.eventID : 0;
	}

	public get layoutHorizontal() {
		return this.layouts[this.layoutIndex][0];
	}

	public get layoutVertical() {
		return this.layouts[this.layoutIndex][1];
	}
}
